import { useCallback } from 'react';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import { PDPFormValues, RequiredTraining } from 'types/pdp';

export default function useRequiredTrainingsField(
  form: UseFormReturn<PDPFormValues>,
) {
  const { getValues, control } = form;

  const {
    fields: requiredTrainings,
    append: appendTraining,
    remove: removeTraining,
    update: updateTraining,
  } = useFieldArray<PDPFormValues, 'requiredTrainings', 'key'>({
    control,
    name: 'requiredTrainings',
    keyName: 'key',
  });

  const addRequiredTraining = useCallback(() => {
    appendTraining({
      name: '',
      status: 'requested',
    });
  }, [appendTraining]);

  const updateRequiredTraining = useCallback(
    (index: number, patch: Partial<RequiredTraining>) => {
      const currentTrainings = getValues('requiredTrainings') || [];
      const training = currentTrainings[index];
      updateTraining(index, { ...training, ...patch });
    },
    [getValues, updateTraining],
  );

  return {
    requiredTrainings,
    addRequiredTraining,
    removeRequiredTraining: removeTraining,
    updateRequiredTraining,
  };
}
